module.exports = __webpack_public_path__ + "img/1F1EC-1F1E6.be941bc7.svg";